module.exports = __webpack_public_path__ + "img/px.d114b857.png";